import { takeLatest, call, put } from "redux-saga/effects";
import api from "Util/api";

const types = {
    GET_COUNTRIES_REQUESTED: "GET_COUNTRIES_REQUESTED",
    GET_COUNTRIES_SUCCEEDED: "GET_COUNTRIES_SUCCEEDED",
    GET_COUNTRIES_FAILED: "GET_COUNTRIES_FAILED"
};

export const actions = {
    getCountries: () => {
        return {
            type: types.GET_COUNTRIES_REQUESTED
        };
    }
};

const defaultState = {
    data: [],
    error: "",
    loading: true
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case types.GET_COUNTRIES_REQUESTED:
            return {
                ...state,
                loading: true
            };
        case types.GET_COUNTRIES_SUCCEEDED:
            return {
                ...state,
                data: action.payload.data,
                loading: false
            };
        case types.GET_COUNTRIES_FAILED:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        default:
            return state;
    }
}

export function* saga() {
    yield takeLatest(types.GET_COUNTRIES_REQUESTED, startGetCountriesWorker);
}

// Saga callback
function* startGetCountriesWorker() {
    try {
        const response = yield call(getCountries);

        if (!response.ok) {
            throw response.data;
        }

        yield put({
            type: types.GET_COUNTRIES_SUCCEEDED,
            payload: response.data
        });
    } catch (e) {
        yield put({ type: types.GET_COUNTRIES_FAILED, payload: e.error });
    }
}

function getCountries() {
    return api.get("/api/subject-profile/countries");
}
